(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedValues(container) {
    var vals = [];
    if (!container) return vals;
    container.querySelectorAll('select').forEach(function (el) {
      if (el.value) vals.push(el.value);
    });
    container.querySelectorAll('fieldset input:checked, input[type="radio"]:checked').forEach(function (el) {
      if (el.value) vals.push(el.value);
    });
    return vals;
  }

  function findMatchingVariant(variants, selectedValues) {
    var selSet = {};
    selectedValues.forEach(function (v) { selSet[v] = true; });
    var match = variants.find(function (v) {
      return v.options.every(function (opt) { return selSet[opt]; });
    });
    return match || variants[0];
  }

  function initWidget(widget) {
    var dataAEl = widget.querySelector('[data-jrm-bundle-a-data]');
    var dataBEl = widget.querySelector('[data-jrm-bundle-b-data]');
    if (!dataAEl || !dataBEl) return;

    var itemAVariants = JSON.parse(dataAEl.textContent);
    var itemBVariants = JSON.parse(dataBEl.textContent);
    var discountCents = parseInt(widget.getAttribute('data-discount-cents') || '0', 10);

    var priceAEl = widget.querySelector('[data-jrm-bundle-price-a]');
    var priceBEl = widget.querySelector('[data-jrm-bundle-price-b]');
    var imgAEl = widget.querySelector('[data-jrm-bundle-img-a]');
    var imgBEl = widget.querySelector('[data-jrm-bundle-img-b]');
    var strikeEl = widget.querySelector('[data-jrm-bundle-strike]');
    var discountEl = widget.querySelector('[data-jrm-bundle-discount]');
    var finalEl = widget.querySelector('[data-jrm-bundle-final]');
    var addBtn = widget.querySelector('[data-jrm-bundle-add]');
    var selectA = widget.querySelector('[data-jrm-bundle-select-a]');
    var selectB = widget.querySelector('[data-jrm-bundle-select-b]');

    // Optional personalization capture: activates only when the widget carries
    // data-personalize-a-trigger / data-personalize-b-trigger attributes, so this
    // stays fully backward-compatible with widgets that don't need it.
    var personalizeAWrap = widget.querySelector('[data-jrm-bundle-personalize-a]');
    var personalizeAInput = widget.querySelector('[data-jrm-bundle-personalize-input-a]');
    var personalizeATrigger = widget.getAttribute('data-personalize-a-trigger') || '';
    var personalizeBWrap = widget.querySelector('[data-jrm-bundle-personalize-b]');
    var personalizeBInput = widget.querySelector('[data-jrm-bundle-personalize-input-b]');
    var personalizeBTrigger = widget.getAttribute('data-personalize-b-trigger') || '';

    // Optional attribution tag: identifies which page/widget a cart add came from.
    // Written as a hidden (underscore-prefixed) line-item property on both items,
    // plus a rolling cart-level note attribute so it's visible at the order level too.
    var bundleTag = widget.getAttribute('data-bundle-tag') || '';

    function attributeCartSource(tag) {
      if (!tag) return Promise.resolve();
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var existing = (cart.attributes && cart.attributes['Bundle Sources']) || '';
        var list = existing ? existing.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
        if (list.indexOf(tag) === -1) list.push(tag);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Bundle Sources': list.join(', ') } })
        });
      }).catch(function () { /* non-fatal: never block checkout on attribution */ });
    }

    var mainVariantSelects = document.querySelector('variant-selects');

    // Default item A to whatever the shopper already has selected in the main
    // product form (if determinable), instead of always defaulting to the
    // first variant in the array. Keeps the bundle box honest about what's
    // actually about to be added for "this item."
    var currentA = itemAVariants[0];
    if (mainVariantSelects && itemAVariants.length > 1) {
      var initialValues = getSelectedValues(mainVariantSelects);
      if (initialValues.length) {
        var initialMatch = findMatchingVariant(itemAVariants, initialValues);
        if (initialMatch) currentA = initialMatch;
      }
    }
    var currentB = itemBVariants[0];

    function updatePersonalizeVisibility(wrap, input, trigger, currentItem) {
      if (!wrap || !trigger) return;
      var needed = currentItem.options && currentItem.options.indexOf(trigger) !== -1;
      wrap.style.display = needed ? '' : 'none';
      if (input) {
        if (needed) input.setAttribute('required', 'required');
        else { input.removeAttribute('required'); input.value = input.value; }
      }
    }

    function render() {
      if (priceAEl) priceAEl.textContent = formatMoney(currentA.price);
      if (priceBEl) priceBEl.textContent = formatMoney(currentB.price);
      if (imgAEl && currentA.image) imgAEl.src = currentA.image;
      if (imgBEl && currentB.image) imgBEl.src = currentB.image;
      if (selectA && String(selectA.value) !== String(currentA.id)) selectA.value = String(currentA.id);
      if (selectB && String(selectB.value) !== String(currentB.id)) selectB.value = String(currentB.id);
      var total = currentA.price + currentB.price;
      var final = Math.max(total - discountCents, 0);
      if (discountCents > 0) {
        if (strikeEl) { strikeEl.style.display = ''; strikeEl.textContent = formatMoney(total); }
        if (discountEl) { discountEl.style.display = ''; discountEl.textContent = '-' + formatMoney(discountCents); }
      } else {
        if (strikeEl) strikeEl.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }
      if (finalEl) finalEl.textContent = formatMoney(final);
      if (addBtn) {
        addBtn.setAttribute('data-variant-a', currentA.id);
        addBtn.setAttribute('data-variant-b', currentB.id);
      }
      updatePersonalizeVisibility(personalizeAWrap, personalizeAInput, personalizeATrigger, currentA);
      updatePersonalizeVisibility(personalizeBWrap, personalizeBInput, personalizeBTrigger, currentB);
    }

    if (selectA) {
      selectA.addEventListener('change', function () {
        var match = itemAVariants.find(function (v) { return String(v.id) === selectA.value; });
        if (match) { currentA = match; render(); }
      });
    }

    if (selectB) {
      selectB.addEventListener('change', function () {
        var match = itemBVariants.find(function (v) { return String(v.id) === selectB.value; });
        if (match) { currentB = match; render(); }
      });
    }

    if (mainVariantSelects && itemAVariants.length > 1) {
      mainVariantSelects.addEventListener('change', function () {
        var values = getSelectedValues(mainVariantSelects);
        if (values.length) {
          currentA = findMatchingVariant(itemAVariants, values);
          render();
        }
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (personalizeAWrap && personalizeAWrap.style.display !== 'none' && personalizeAInput && !personalizeAInput.value.trim()) {
          alert('Please enter your personalization text before adding this bundle to your cart.');
          personalizeAInput.focus();
          return;
        }
        if (personalizeBWrap && personalizeBWrap.style.display !== 'none' && personalizeBInput && !personalizeBInput.value.trim()) {
          alert('Please enter your personalization text before adding this bundle to your cart.');
          personalizeBInput.focus();
          return;
        }

        var itemA = { id: currentA.id, quantity: 1 };
        if (personalizeAWrap && personalizeAWrap.style.display !== 'none' && personalizeAInput) {
          itemA.properties = {};
          itemA.properties[personalizeAInput.getAttribute('data-jrm-bundle-personalize-label') || 'Personalization'] = personalizeAInput.value.trim();
        }
        var itemB = { id: currentB.id, quantity: 1 };
        if (personalizeBWrap && personalizeBWrap.style.display !== 'none' && personalizeBInput) {
          itemB.properties = {};
          itemB.properties[personalizeBInput.getAttribute('data-jrm-bundle-personalize-label') || 'Personalization'] = personalizeBInput.value.trim();
        }
        if (bundleTag) {
          itemA.properties = itemA.properties || {};
          itemA.properties['_bundle_source'] = bundleTag;
          itemB.properties = itemB.properties || {};
          itemB.properties['_bundle_source'] = bundleTag;
        }

        var originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [itemA, itemB]
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('add to cart failed');
          return res.json();
        }).then(function () {
          return attributeCartSource(bundleTag);
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
          alert('Sorry, something went wrong adding the bundle to your cart. Please try adding each item individually.');
        });
      });
    }

    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-jrm-bundle]').forEach(initWidget);
  });
})();
